import React, { useRef, useState, useEffect } from 'react';
import { TextV2Props } from '@withjoy/joykit';
import { NoteText, StyledLinkify, NoteTextWrapper } from './CoupleHeader.styles';
import { useIsomorphicLayoutEffect } from '@shared/utils/hooks/useIsomorphicLayoutEffect';
import { useIsMounted } from '@shared/utils/hooks/useIsMounted';
import globalWindow from '@shared/core/globals';

type PageNoteTextProps = {
  noteText: Maybe<string>;
  renderReadMore?: () => React.ReactNode;
  showFullPageNote: boolean;
};

export const PageNoteText: React.FC<PageNoteTextProps & TextV2Props> = ({ noteText = '', renderReadMore, showFullPageNote, ...textProps }) => {
  const noteRef = useRef<HTMLDivElement>(null);
  const [hasMore, setHasMore] = useState(false);

  const [, setHasMountedOnce] = useState(false);

  const isMounted = useIsMounted();
  useEffect(() => {
    let timeout: ReturnType<typeof globalWindow.setTimeout>;
    if (isMounted) {
      timeout = globalWindow.setTimeout(() => {
        setHasMountedOnce(true);
      }, 1000);
    }
    return () => {
      globalWindow.clearTimeout(timeout);
    };
  }, [isMounted]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useIsomorphicLayoutEffect(() => {
    if (noteRef.current && noteRef.current.offsetHeight < noteRef.current.scrollHeight) {
      setHasMore(true);
    }
  });

  return (
    <div>
      <NoteTextWrapper isOpen={showFullPageNote} ref={noteRef}>
        <NoteText {...textProps} typographyVariant="body4" isOpen={showFullPageNote}>
          <StyledLinkify>{noteText}</StyledLinkify>
        </NoteText>
      </NoteTextWrapper>
      {hasMore && renderReadMore?.()}
    </div>
  );
};
